
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Paul Weise',
      role: 'Business Owner',
      company: 'Door Serv Pro',
      rating: 5,
      text: 'I cant say enough good about Shawn and his business Benson Designs. Absolutely killed it on my company branding!!! He has done wraps on 6 of 9 trucks, our trailers, scissor lifts, walls and garage doors! We will continue to have him wrap all future company vehicle\'s and equipment! Thank you man... Keep Killing It!',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/3bac255f81d4524716a859472121f739.png'
    },
    {
      name: 'Eric Schriver',
      role: 'Business Owner',
      company: 'Devils in the Detailing',
      rating: 5,
      text: 'I have used Benson Designs for tint on all of our vehicles, and Chrome delete on our new Yukon as well as a custom design vinyl wrap on our shop truck. Every time Shawn continues to deliver top notch customer service and his attention to detail is amazing! Absolutely a master of his craft!',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/e3b18ff4177f2a479c2e1699e714ec7f.png'
    },
    {
      name: 'John Wilt',
      role: 'Patron',
      company: '',
      rating: 5,
      text: 'Great work on both cars. Next up is maybe some graphics. He done the front windshield strip and the front doors on my new rogue and he had done all the windows in my 2019 rogue sport I traded in. Thanks for the great work',
      image: 'https://public.readdy.ai/ai/img_res/fa283329b9601c448f7799a1b1acbe19.jpg'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say 
            about our quality work and exceptional service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-800 rounded-xl p-8 shadow-xl border border-gray-700 hover:border-blue-500/50 transition-all duration-300">
              {/* Rating Stars */}
              <div className="flex items-center mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center text-yellow-400">
                    <i className="ri-star-fill"></i>
                  </div>
                ))}
              </div>

              {/* Testimonial Text */}
              <blockquote className="text-gray-300 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </blockquote>

              {/* Client Info */}
              <div className="flex items-center">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-400 text-sm">{testimonial.role}</p>
                  <p className="text-blue-400 text-sm font-medium">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gray-800 rounded-2xl p-8 md:p-12 inline-block border border-gray-700">
            <div className="flex items-center justify-center mb-6">
              <div className="flex items-center space-x-2 text-4xl text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-star-fill"></i>
                  </div>
                ))}
              </div>
            </div>
            <h3 className="text-2xl font-bold text-white mb-2">4.9/5 Average Rating</h3>
            <p className="text-gray-300 mb-6">Based on 150+ customer reviews</p>
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap font-medium">
              Read All Reviews
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
